import { render, staticRenderFns } from "./mfa-methods.vue?vue&type=template&id=64db6ee2&scoped=true&"
import script from "./mfa-methods.vue?vue&type=script&lang=js&"
export * from "./mfa-methods.vue?vue&type=script&lang=js&"
import style0 from "./mfa-methods.vue?vue&type=style&index=0&id=64db6ee2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64db6ee2",
  null
  
)

export default component.exports